import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import { Spinner } from 'libs.nucleus';
const BASE_URL = `//unpkg.com/pdfjs-dist@${pdfjs.version}`;
pdfjs.GlobalWorkerOptions.workerSrc = `${BASE_URL}/build/pdf.worker.min.mjs`;
const options = {
    cMapUrl: `https://${BASE_URL}/cmaps/`,
    standardFontDataUrl: `https://${BASE_URL}/standard_fonts/`,
};
export const PDFRenderer = ({ PDFUrl }) => {
    const [numPages, setNumPages] = useState(0);
    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    };
    return (_jsx(Document, { file: PDFUrl, onLoadSuccess: onDocumentLoadSuccess, options: options, className: 'overflow-y-auto h-full', loading: _jsx(Spinner, { wrapper: 'full' }), children: Array.from({ length: numPages }, (_, index) => (_jsx(Page, { pageNumber: index + 1, width: window.innerWidth * 0.95 }, index))) }));
};
